import supabase from '../utils/supabase';

class LogService {
    private currentCallId: string | null = null;
    private currentUserId: string | null = null;
    private originalConsole: any = {};
    private isInitialized = false;

    constructor() {
        this.originalConsole = {
            log: console.log.bind(console),
            warn: console.warn.bind(console),
            error: console.error.bind(console),
            debug: console.debug.bind(console),
        };
    }

    init(userId: string) {
        if (this.isInitialized) return;
        this.currentUserId = userId;
        this.interceptConsole();
        this.isInitialized = true;
        this.originalConsole.log('[LogService] Initialized for user:', userId);
    }

    setCallContext(callId: string) {
        this.currentCallId = callId;
        this.originalConsole.log('[LogService] Call context set:', callId);
    }

    clearCallContext() {
        this.originalConsole.log('[LogService] Call context cleared:', this.currentCallId);
        this.currentCallId = null;
    }

    private interceptConsole() {
        const levels = ['log', 'warn', 'error', 'debug'];
        levels.forEach(level => {
            (console as any)[level] = (...args: any[]) => {
                // Call original
                this.originalConsole[level](...args);

                // Forward to Supabase if callId is active
                if (this.currentCallId) {
                    this.forwardToSupabase(level, args);
                }
            };
        });
    }

    private async forwardToSupabase(level: string, args: any[]) {
        try {
            // Avoid circular logging if supabase client logs something (unlikely with minimal set)
            const message = args.map(arg => {
                if (typeof arg === 'object') {
                    try {
                        return JSON.stringify(arg);
                    } catch (e) {
                        return '[Circular or Non-Serializable Object]';
                    }
                }
                return String(arg);
            }).join(' ');

            // Use a background call to not block the main thread
            supabase.from('Log').insert({
                call_id: this.currentCallId,
                source: 'browser',
                level: level === 'log' ? 'info' : level,
                message: message,
                userId: this.currentUserId
            }).then(() => {});
        } catch (e) {
            this.originalConsole.error('[LogService] Error in forwardToSupabase:', e);
        }
    }
}

export const logService = new LogService();
export default logService;
